import React from "react";
import useEngagementIds from "hooks/engagement/useEngagementIds";
import useEngagementClient from "hooks/engagement/useEngagementClient";

const useEngagementActions = (bookId) => {
	const { al_sid, al_vid } = useEngagementIds();
	const { send } = useEngagementClient(bookId);

	const sendAction = React.useCallback(
		(event) => {
			send({ event, al_sid, al_vid });
		},
		[send, al_sid, al_vid]
	);

	return {
		sendAddToCartSuccess: () => sendAction("click_add_to_cart"),
		sendAddToPicks: () => sendAction("click_add_to_picks"),
		sendRemoveFromLibrary: () => sendAction("remove_from_library"),
		sendFormatToggle: () => sendAction("format_toggle"),
	};
};

export default useEngagementActions;
